<script>
export default {
  name: "AlSalads",
  data() {
    return {
      salads: [
        {
          name: "Vitamin sallatë",
          text: "Lettuce, lakre, karrotë, sallatë dresing",
          price: "90 den.",
        },
        {
          name: "Cesar sallatë",
          text: "Sallata, pule, kubeti, domatja qershi, parmezan, misër, sallatë dresing",
          price: "170 den.",
        },
        {
          name: "Tuna sallatë",
          text: "Sallata, tuna, qepë, domatja qershi, misër, sallatë dresing",
          price: "220 den.",
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="salad in salads" :key="salad.name">
    <v-card-title>{{ salad.name }}</v-card-title>
    <v-card-text>{{ salad.text }}</v-card-text>
    <v-card-actions class="flex text-right"
    ><v-spacer></v-spacer>{{ salad.price }}</v-card-actions
    >
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>